import { Timestamp } from 'firebase/firestore';
import { ISubmission } from '@core/interfaces/ISubmission';
import { IDocumentJsonSubmission } from '../interfaces/IDocumentJsonSubmission';
import { IDocumentDataSubmission } from '../interfaces/IDocumentDataSubmission';

export const transformDataToSubmission = ({
    creationDate,
    lastUpdateDate,
    lilmStatusUpdateDate,
    lilmInternalStatusUpdateDate,
    ...rest
}:IDocumentDataSubmission):ISubmission => ({
    ...rest,
    ...(creationDate && {
        creationDate: creationDate.toDate(),
    }),
    ...(lastUpdateDate && {
        lastUpdateDate: lastUpdateDate.toDate(),
    }),
    ...(lilmStatusUpdateDate && {
        lilmStatusUpdateDate: lilmStatusUpdateDate.toDate(),
    }),
    ...(lilmInternalStatusUpdateDate && {
        lilmInternalStatusUpdateDate: lilmInternalStatusUpdateDate.toDate(),
    }),
});

export const transformJsonToSubmission = ({
    creationDate,
    lastUpdateDate,
    ...rest
}:IDocumentJsonSubmission):ISubmission => ({
    ...rest,
    creationDate   : new Date(creationDate),
    lastUpdateDate : new Date(lastUpdateDate),
});

export const transformSubmissionToData = ({
    creationDate,
    lastUpdateDate,
    lilmStatusUpdateDate,
    lilmInternalStatusUpdateDate,
    ...rest
}:ISubmission):IDocumentDataSubmission => ({
    ...rest,
    ...(creationDate && {
        creationDate: Timestamp.fromDate(creationDate),
    }),
    ...(lastUpdateDate && {
        lastUpdateDate: Timestamp.fromDate(lastUpdateDate),
    }),
    ...(lilmStatusUpdateDate && {
        lilmStatusUpdateDate: Timestamp.fromDate(lilmStatusUpdateDate),
    }),
    ...(lilmInternalStatusUpdateDate && {
        lilmInternalStatusUpdateDate: Timestamp.fromDate(lilmInternalStatusUpdateDate),
    }),
});
